type Props = {
  onCreateManual: () => void
}

export function EmptyShopState({ onCreateManual }: Props) {
  return (
    <section className="mb-[14px] rounded-[18px] border border-dashed border-border-sand bg-paper/60 px-4 py-8 text-center">
      <h2 className="font-serif text-[18px] font-normal text-ink leading-[1.2]">
        <em className="italic">All stocked up.</em>
      </h2>
      <p className="mt-2 font-serif text-[13px] italic text-ink-muted leading-[1.45]">
        Nothing is running low right now.<br />Need something anyway?
      </p>
      <button
        onClick={onCreateManual}
        className="mt-4 rounded-[10px] bg-forest px-4 py-[9px] text-[12px] font-bold text-forest-ink"
      >
        Start a list
      </button>
    </section>
  )
}
